import type { MutationHookOptions } from '@apollo/client'
import {
  AccessesDocument,
  DeactivateExternalUserDocument,
  DeactivateExternalUserMutation,
  DeactivateExternalUserMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  DeactivateExternalUserMutation,
  DeactivateExternalUserMutationVariables
>

export const useDeactivateAccess = (options?: Options) => {
  const [deactivateAccess, { loading }] = useMutation(DeactivateExternalUserDocument, {
    ...options,
    extractorFn: (data) => data.apiCoreMutations.deactivateApicoreAccess,
  })

  return {
    loading,
    deactivate(variables: DeactivateExternalUserMutationVariables) {
      return deactivateAccess({
        variables,
        refetchQueries: [AccessesDocument],
      })
    },
  }
}
